<script>
	import { onMount } from 'svelte';
	import { goto, ready } from '@roxi/routify';
	import Navbar from "../components/Navbar.svelte";
	import Footer from "../components/Footer.svelte";
</script>

<main class="background">
	<Navbar/>
	<div class="flex flex-col space-y-4 h-3/4 mt-10 items-center">
		<div class="mx-2 !mb-4 px-10 py-12 max-w-4xl w-full flex-1 card">
			<p class="text-2xl font-semibold text-blue-900 mb-3">FAQs</p>
			<iframe class="w-full h-[90%]" src="https://docs.google.com/document/d/e/2PACX-1vS9JvhLSGfKgqBnAQNO1-gBY9Uo-TPl9Krlh6Cqz-kl00tIr_AznxJ4WclPyBE8QtG228NlXvWuFEtm/pub?embedded=true"></iframe>
		</div>
	</div>
	<Footer/>	
</main>

<style>
	main.background {
		@apply h-screen absolute;
		background-color:theme("colors.gray.100");
	}
</style>